import config from '../../config';
import API from '../api';

const { baseUrl } = config.coreApi;

const createPortal = async portalData => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals`;

  return fetch(url, {
    method: 'POST',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(portalData)
  }).then(res => API.generateResponse(res));
};

const getPortals = async (pageSize = 40, page = '', filter = '', orderBy = 'displayName, id') => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals?pageSize=${pageSize}&pageToken=${page}&filter=${filter}&orderBy=${orderBy}`;
  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const getPortal = async bpid => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}`;
  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const inviteUserToPortal = async (bpid, user) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}:inviteUser`;

  return fetch(url, {
    method: 'POST',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(user)
  }).then(res => API.generateResponse(res));
};

const getPortalPolicy = async bpid => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}:getPolicyV2`;
  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const setPortalPolicy = async (bpid, policy) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}:setPolicyV2`;

  return fetch(url, {
    method: 'PATCH',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(policy)
  }).then(res => API.generateResponse(res));
};

const updatePortal = async (portal, fields) => {
  await API.refreshTokenWhenNeeded();
  const paths = `updateMask=${fields.join(',')}`;
  const body = {};
  fields.forEach(field => {
    body[field] = portal[field];
  });
  const url = `${baseUrl}/brandportals/${portal.id}?${paths}`;

  return fetch(url, {
    method: 'PATCH',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(body)
  }).then(res => API.generateResponse(res));
};

const deletePortal = async bpid => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${bpid}`;

  return fetch(url, {
    method: 'DELETE',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() }
  }).then(res => API.generateResponse(res));
};

export {
  createPortal,
  getPortals,
  getPortal,
  inviteUserToPortal,
  getPortalPolicy,
  updatePortal,
  deletePortal,
  setPortalPolicy
};
